import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
// import { MatFormFieldModule } from '@angular/material/form-field-module.d';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { HeaderStyleOneComponent } from 'src/app/components/common/header-style-one/header-style-one.component';
import { TrimLeadingSpace } from 'src/app/directives/trim-leading-space';
import { MaterialModule } from 'src/app/material.module';
import { Apiservice } from 'src/app/services/apiservice';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-profile',
  imports: [MatTableModule, MatPaginatorModule, MatFormFieldModule, MatInputModule, MatSortModule, CommonModule, FormsModule, MaterialModule, NgSelectModule, ReactiveFormsModule, HeaderStyleOneComponent, TrimLeadingSpace, RouterLink],
  templateUrl: './profile.html',
  styleUrl: './profile.scss'
})
export class Profile {
  // district_id: any;
  // ulb_id: any;
  // selectSlf: any;

  isSticky: boolean = false;
  showloader: boolean;
  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (scrollPosition >= 50) {
      this.isSticky = true;
    } else {
      this.isSticky = false;
    }
  }

  isToggled = false;
  userData: any = null;


  districtData: any = [];
  ulbData: any = [];
  slfData: any = [];
  shgGropsReport: any = [];
  shgmembersReport: any = [];
  registrationform: FormGroup
  photoPreview: any = null;
  // showloader: any;
  relationships: any = [
    { id: 1, name: "Father" },
    { id: 2, name: "Mother" },
    { id: 3, name: "Husband" },
    { id: 4, name: "Wife" },
    { id: 5, name: "Son" },
    { id: 6, name: "Daughter" },
    { id: 7, name: "Brother" },
    { id: 8, name: "Sister" },
    { id: 9, name: "Uncle" },
    { id: 10, name: "Aunt" },
    { id: 11, name: "Cousin" },
    { id: 12, name: "Grandfather" },
    { id: 13, name: "Grandmother" },
    { id: 14, name: "Guardian" },
    { id: 15, name: "Other" }
  ];
  qualifications: any = [
    { value: '10th', label: '10th Standard' },
    { value: '12th', label: '12th Standard' },
    { value: 'Diploma', label: 'Diploma' },
    { value: 'Degree', label: 'Degree' },
    { value: 'B.Tech', label: 'B.Tech' },
    { value: 'M.Tech', label: 'M.Tech' },
    { value: 'MBA', label: 'MBA' },
    { value: 'MCA', label: 'MCA' },
    { value: 'PhD', label: 'PhD' },
    { value: 'Others', label: 'Others' }
  ];
  submittedregist: boolean;
  currentdate: any = new Date().toISOString().slice(0, 10)
  @ViewChild('formContainer') formContainer: ElementRef;

  currentTab = 'tab1';

  headerclass = {
    // 'fontSize.px': 17,
    'fontWeight': 'bold',
    'background': '#BA4D13',
    'color': '#fff',
    'text-align': 'center',
    // 'padding': '8px',
  };
  filteredData: any[] = [];   // Filtered data based on search
  searchTerm: string = '';    // Search term
  sortColumn: string = '';   // Column to sort by
  sortDirection: 'asc' | 'desc' = 'asc';  // Sort direction
  @ViewChild(MatPaginator) paginator: MatPaginator;      // Mat Table Pagination selector
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('firstTableSort') public firstTableSort: MatSort;                     // Mat Table Sorting selector
  // 'vacancies',
  // 'age_limit', 'salary',
  displayedColumns: string[] = ['i', 'district_name', 'mela_date', 'mela_name', 'payment_date', 'payment_status', 'action'];
  dataSource: MatTableDataSource<any>;
  results_notifications_list: any = [];
  serch: any;
  jobsScrollData: any = [
    {
      "message": "MEPMA-NIPUNA JOB MELA 2025"
    }]

  // districtData: any = [];
  // showloader: any;
  melanotifcations: any = [];
  userDetails: any = [];
  constructor(private fb: FormBuilder, private api: Apiservice, private router: Router, private acrouter: ActivatedRoute) { }
  ngOnInit(): void {

    this.registrationform = this.fb.group({
      are_you_shg: ['', Validators.required],
      district_id: ['', Validators.required],
      ulb_id: ['', Validators.required],
      slf_id: ['', Validators.required],
      shg_id: ['', Validators.required],
      member_id: ['', Validators.required],
      relation_with_shg: [''],
      // 1. Personal Information
      full_name: [''],
      father_or_husband_name: ['', Validators.required],
      date_of_birth: ['', Validators.required],
      gender: ['', Validators.required],
      contact_number: [''],
      email: ['', [Validators.required, Validators.email]],
      aadhaar_number: ['', [Validators.required, Validators.pattern('^\\d{12}$')]],
      address: ['', Validators.required],

      // 2. Educational Qualification
      highest_qualification: ['', Validators.required],
      year_of_passing: ['', Validators.required],
      university_or_board: ['', Validators.required],

      // 3. Employment Details
      currently_employed: ['', Validators.required],
      work_company_name: [''],
      designation: [''],
      work_experience: ['']
    });
    this.registrationform.get('are_you_shg')?.valueChanges.subscribe(value => {
      const relationControl = this.registrationform.get('relation_with_shg');
    });
    this.registrationform.get('currently_employed')?.valueChanges.subscribe(value => {
    });
    this.acrouter.queryParams.subscribe((res: any) => {
      console.log(res);
      this.getProfileData(res);

    });

    // this.getProfileData();
    // this.getgetDistrictData();
    // this.getUserAppliedApplications();

  }
  getProfileData(res) {
    let obj = {
      userId: res.reqId
    }
    console.log(obj);

    this.api.getUserprofileQrData(obj).subscribe((res: any) => {
      console.log(res);
      this.showloader = false;
      if (res.status == 200) {
        let user = res.data[0];
        this.userDetails = res.data;
        console.log(user);
        this.getUserAppliedApplications(user.id);

        this.photoPreview = user?.image;
        this.registrationform.patchValue({
          are_you_shg: user?.are_you_shg,
          district_id: user?.district_name,
          ulb_id: user?.ulb_name,
          slf_id: user?.slf_name,
          shg_id: user?.shg_group_name,
          member_id: user?.shg_member_name,
          relation_with_shg: user?.relation_with_shg,
          // 1. Personal Information
          full_name: user?.user_name,
          father_or_husband_name: user?.father_or_husband_name,
          date_of_birth: user?.date_of_birth,
          gender: user?.gender,
          contact_number: user?.phone_number,
          email: user?.email,
          aadhaar_number: user?.aadhaar_number,
          address: user?.address,

          // 2. Educational Qualification
          highest_qualification: user?.highest_qualification,
          year_of_passing: user?.year_of_passing,
          university_or_board: user?.university_or_board,

          // 3. Employment Details
          currently_employed: user?.currently_employed,
          work_company_name: user?.work_company_name,
          designation: user?.designation,
          work_experience: user?.work_experience
        });
      }
    }, err => {
      this.showloader = false;
    })
  }
  // getgetDistrictData() {
  //   this.showloader = true;
  //   this.api.getDistrictData().subscribe((res: any) => {
  //     this.showloader = false;
  //     if (res.status == 200) {
  //       this.districtData = res.data;
  //       console.log(this.districtData);

  //     }
  //   }, err => {
  //     this.showloader = false;
  //   });
  // };
  // getUlbData(event) {
  //   this.showloader = true;
  //   console.log(event);
  //   this.ulbData = [];
  //   this.registrationform.get('ulb_id')?.reset();
  //   this.registrationform.get('slf_id')?.reset();
  //   this.registrationform.get('shg_id')?.reset();
  //   this.registrationform.get('member_id')?.reset();
  //   // this.ulb_id = '';
  //   let obj = {
  //     district_id: event
  //   };
  //   this.api.getUlbData(obj).subscribe((res: any) => {
  //     this.showloader = false;
  //     if (res.status == 200) {
  //       this.ulbData = res.data;
  //       console.log(this.ulbData);
  //     }
  //   }, err => {
  //     this.showloader = false;
  //   });
  // }

  // getSLFdetails(event) {
  //   console.log(event);
  //   this.showloader = true;
  //   let obj = {
  //     ulb_id: event,
  //   }
  //   console.log(obj)
  //   this.slfData = [];
  //   this.registrationform.get('slf_id')?.reset();
  //   this.registrationform.get('shg_id')?.reset();
  //   this.registrationform.get('member_id')?.reset();
  //   this.api.getulbbasedSlfData(obj).subscribe((res: any) => {
  //     this.showloader = false;
  //     if (res.status == 200) {
  //       this.slfData = res.data;
  //       console.log(this.slfData);
  //     };

  //   }, err => {
  //     this.showloader = false;
  //   })
  // };
  // getShgGropsReport(event) {
  //   console.log(event);
  //   this.showloader = true;
  //   let obj = {
  //     slf_id: event.slf_id ?? event
  //   };
  //   this.shgGropsReport = [];
  //   this.registrationform.get('shg_id')?.reset();
  //   this.registrationform.get('member_id')?.reset();
  //   this.api.getShgGropsReport(obj).subscribe((res: any) => {
  //     if (res.status == 200) {
  //       this.shgGropsReport = res.data;
  //       console.log(this.shgGropsReport);
  //       this.showloader = false;
  //     }
  //   }, err => {
  //     this.showloader = false;
  //   });
  // }
  // getShgmembersReport(event) {
  //   console.log(event);
  //   this.showloader = true;
  //   // this.vendorDetails.group_id = event.shg_group_id;
  //   // this.vendorDetails.group_name = event.shg_group_name;
  //   let obj = {
  //     shg_group_id: event
  //   }
  //   console.log(obj)
  //   this.shgmembersReport = [];
  //   this.registrationform.get('member_id')?.reset();
  //   this.api.getShgbasedmembersData(obj).subscribe((res: any) => {
  //     this.showloader = false;
  //     if (res.status == 200) {
  //       // console.log(res);
  //       this.shgmembersReport = res.data;
  //       console.log(this.shgmembersReport);

  //     }
  //   }, err => {
  //     this.showloader = false;
  //   })

  // }
  // getShgmemberdetails(event) {
  //   console.log(event);
  //   let memberdata = this.shgmembersReport.filter(a => a.member_id == event);
  //   this.registrationform.patchValue({
  //     full_name: memberdata[0].member_name
  //   })
  //   const control = this.registrationform.get('full_name');
  //   control.updateValueAndValidity();
  //   // this.vendorDetails.member_id = event.member_id;
  //   // this.vendorDetails.group_member_name = event.member_name;
  // }



  // getadminSlfReport(event) {

  // }
  // getShgTotalReport(event) {

  // }
  get regist() { return this.registrationform.controls; }
  submitRegistrationDetails() {
    // console.log(this.registrationform.value);
    const control = this.registrationform.get('full_name');
    control.updateValueAndValidity();
    this.submittedregist = true;
    if (this.registrationform.invalid) {
      console.log('hiii', this.registrationform.controls)
      setTimeout(() => {
        const firstInvalid = this.formContainer.nativeElement.querySelector('.ng-invalid');
        if (firstInvalid) {
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstInvalid.focus();
        }
      }, 0);
      return;
    } else {
      if (this.photoPreview != null) {
        this.registrationform.value.profileImg = this.photoPreview;
        console.log(this.registrationform.value);
        this.showloader = true;
        this.api.submitRegistrationDetails(this.registrationform.value).subscribe((res: any) => {
          this.showloader = false;
          this.submittedregist = false;

          if (res.status === 200) {
            this.registrationform.reset();
            this.photoPreview = null;
            Swal.fire({
              icon: 'success',
              title: 'Registration Successful',
              text: 'Your details have been submitted successfully.',
              confirmButtonText: 'OK'
            });
          } else {
            Swal.fire({
              icon: 'warning',
              title: 'Submission Failed',
              text: res.message || 'Something went wrong.',
              confirmButtonText: 'Retry'
            });
          }
        },
          (err) => {
            this.showloader = false;
            console.error('API error:', err);
          });
      } else {
        alert('Please upload picture')
      }
    }
  };

  newnumaricprevent(event: Event) {
    const input = event.target as HTMLInputElement;
    input.value = input.value.replace(/[^0-9]/g, '');
  }

  onImageChange(e: any) {
    console.log(e);
    const reader = new FileReader();
    if (e.target.files && e.target.files.length) {
      const [file] = e.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.photoPreview = reader.result;
        var imgFile = reader.result as string;
        console.log(e.target.files[0].name);
        var bfile_typeEmpl = e.target.files[0].name.split('.');
        console.log("bfile: ", bfile_typeEmpl);
        var imgtype = bfile_typeEmpl[bfile_typeEmpl.length - 1];
        console.log(imgtype);
        // this.imageData.push({ reviewimg: imgFile, filetype: imgtype });
        // console.log("image data", this.imageData, this.imageData[0].filetype);
      };
    }
  }

  logout() {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will be logged out of the session.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, logout',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        // 👉 Add your logout logic here
        // For example:
        localStorage.clear();
        sessionStorage.clear();
        // Navigate to login page
        this.router.navigate(['/'], { replaceUrl: true });

        Swal.fire({
          title: 'Logged out',
          text: 'You have been logged out successfully.',
          icon: 'success',
          timer: 2000,
          showConfirmButton: false
        });
        location.reload();
      }
    });
  }

  switchTab(event: MouseEvent, tab: string) {
    event.preventDefault();
    this.currentTab = tab;
  };

  getUserAppliedApplications(userId) {
    let obj = {
      userId: userId
    }
    console.log(obj);

    this.api.getUserAppliedQrApplications(obj).subscribe((res: any) => {
      this.showloader = false;
      if (res.status == 200) {
        console.log(res);
        // this.shgmembersReport = res.data;
        // console.log(this.shgmembersReport);
        res.data.map(((respo, index) => {
          respo.i = index + 1;
        }))
        this.dataSource = new MatTableDataSource(res.data);
        console.log(this.dataSource);
        setTimeout(() => {
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }, 500);
      }
    }, err => {
      this.showloader = false;
    })
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  gotoviewDetails(data) {
    // this.router.navigate(['/idcard'])

    this.router.navigateByUrl('/print-idcard', {
      state: {
        userDetails: this.userDetails,
        melaDetails: data
      },
    });
  }
  classApplied = false;
  toggleClass() {
    this.classApplied = !this.classApplied;
  }

  classApplied2 = false;
  toggleClass2() {
    this.classApplied2 = !this.classApplied2;
  }

  classApplied3 = false;
  toggleClass3() {
    this.classApplied3 = !this.classApplied3;
  }
}